import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/invoice/:id',
    name: 'InvoicePage',
    component: () => import('@/modules/invoice/views/InvoicePage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
